import {
  isMobilePhone,
  isMobileTablet,
} from '../../library/calc';
import './Iconbox.css';
import {
  imageBasePath,
  borderColor,
  fontFamily,
} from '../../library/constants';
import React, { Component } from 'react';

// import { translateMenuItemActions } from './moreMenuActions';

class IconBox extends Component {

  constructor(props){
    super(props);
    this.checkedAllMorePermissions = false;
  }


  // componentDidUpdate (prevProps, prevState, snapshot){

  //   console.log('componentDidUpdate');

  // }

  greyOut(){

   let {
    engLabel,
    flipData,
   } = this.props;

    if (Object.is(flipData, null)) {
      return false;
    }

    let greyOut = false;

    if(engLabel==='add'){
      greyOut = ( typeof(flipData.display.nearby_tree_matches) !== 'undefined' && flipData.display.nearby_tree_matches ) ;

    }

    return greyOut;

  }


  disable(){

   let {
    engLabel,
    flipData,
    translatedLabels,
   } = this.props;


    if( flipData === null || typeof(flipData) === 'undefined') {
      return true;
    } else {
      let doDisable = false;

      if(engLabel==='add'){

        doDisable = !(flipData.display.action_add) || ( typeof(flipData.display.nearby_tree_matches) !== 'undefined' && flipData.display.nearby_tree_matches ) ;
        // doDisable = (flipData.display.action_add) && !(flipData.display.action_edit);

      } else if(engLabel==='edit'){
        doDisable = !(flipData.display.action_edit);
      } else if(engLabel==='more'){

        doDisable = !(flipData.display.action_edit) && !(flipData.display.action_add);

        if (flipData.display.action_more) doDisable = false;

      } else if(
          engLabel==='more' &&
          !this.checkedAllMorePermissions
        ){
        doDisable = this.moreMenuHasNoPermissionsAtAll({display: flipData.display, translatedLabels});
      }

      return doDisable;

    }

  }

  touchedIcon(){

    const {
      action,
      nodeForFlipFocus,
      nodeObjs,
      stopStageClickPropagation,
   } = this.props;

    if(this.disable()) return;
    stopStageClickPropagation({fromWhere: 'iconbox'});
    const n = nodeForFlipFocus;
    action(nodeObjs[n].pr_id);

  }

  moreMenuHasNoPermissionsAtAll({display, translatedLabels}){

    return false;

    // always show icon because of 'action_view_profile' is always available for users

/*
    const menuItemActions = translateMenuItemActions( translatedLabels );

    if(!this.checkedAllMorePermissions){
      this.checkedAllMorePermissions = true;

      let hasNoPermissions = true;

      menuItemActions.forEach( ( actionObj ) => {
        const permission = actionObj.permission;
        if(display[permission]) hasNoPermissions = false;
      })

      return hasNoPermissions;

    }
*/

  }

  render () {

    let {
      idx,
      imgFile,
      iconBoxSide,
      action,
      label,
      nodeForFlipFocus,
      nodeObjs,
      flipData,
      fetchIsLoading,
      showHookMessageForNearbyTreeMatches,
    } = this.props;

    const isTreeIconBox = idx === 0;
    const isAddIconBox = idx === 2;

    let editIsFalseAddIsTrueForAddIcon = false;
    let editIsTrueAddIsFalseForMoreIcon = false;

    if( flipData && typeof(flipData) !== 'undefined'){

      editIsFalseAddIsTrueForAddIcon = idx === 2 &&
      flipData &&
      typeof(flipData) !== 'undefined' &&
      flipData.display.action_add && !flipData.display.action_edit;

      editIsTrueAddIsFalseForMoreIcon = idx === 3 &&
      flipData &&
      typeof(flipData) !== 'undefined' &&
      !flipData.display.action_add && flipData.display.action_edit;


    }

    const greyOutAdd = ()=> {
      return this.greyOut() && isAddIconBox;
    }

    let iconBoxStyle = {
      position: 'relative',
      whiteSpace: 'nowrap',
      float: `left`,
      width: `${ iconBoxSide }px`,
      height: `${ iconBoxSide }px`,
      fontSize: '13px',
      fontFamily: `${ fontFamily }`,
      padding: '4px 0px',
      boxSizing: 'border-box',
      borderWidth: `1px`,
      borderStyle: `solid`,
      borderColor: borderColor,
      cursor: ( this.disable() || greyOutAdd() ? 'default' : 'pointer'),
      opacity: ( this.disable() || fetchIsLoading || greyOutAdd() ? .4 : 1),
      borderRightWidth: '1px',
      borderLeftWidth: ( this.disable() || isTreeIconBox ? '1px':'0px'),
    }

    if(editIsFalseAddIsTrueForAddIcon) iconBoxStyle = {...iconBoxStyle, borderLeftWidth: '1px'}
    if(editIsTrueAddIsFalseForMoreIcon) iconBoxStyle = {...iconBoxStyle, borderLeftWidth: '1px'}

    let divImgStyle = {
      backgroundImage: `url(${imageBasePath}${imgFile})`,
      backgroundSize: '35px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      width: `${ iconBoxSide }px`,
      height: `${ iconBoxSide }px`,
      opacity: .6,
      position: 'absolute',
      cursor: ( this.disable() ? 'default' : 'pointer'),
    };

    const textStyle = {
      textAlign: `center`
    }

    const classNames = ['icon-boxes']

    if(this.disable()) classNames.push('isDisabled');

    return (
      <div className={classNames} style={iconBoxStyle}

        onTouchMove={(e)=>{
           e.preventDefault();
        }}

        onTouchStart={(e)=>{
          e.stopPropagation();
          if(this.disable()) return;
          if(isMobileTablet()){
            const n = nodeForFlipFocus;
            if (nodeObjs[n]) {
                action(nodeObjs[n].pr_id, n);
            }
          } else {
            this.touchedIcon();
          }
        }}

        onClick={(e)=>{
          if(greyOutAdd()){
            showHookMessageForNearbyTreeMatches({ node: nodeForFlipFocus })
          }
          if(this.disable()) return;
          if(!isMobilePhone()) {
            e.stopPropagation();
            const n = nodeForFlipFocus;
            action(nodeObjs[n].pr_id, n);
          }
        }}
      >
        <div>
          <div style={divImgStyle}></div>
        </div>
        <div style={textStyle} >
          {label}
        </div>
      </div>
    );
  }
}

export default IconBox;

/*
          <img style={imgStyle} alt="" src={`${imageBasePath}${imgFile}`} />

 */

